package com.karawek.core.network

import com.karawek.core.auth.api.AuthCredentialType
import io.ktor.util.AttributeKey

sealed interface AuthMode {

    data object None : AuthMode
    data object Jwt : AuthMode
    data object SessionToken : AuthMode

    fun credentialType(): AuthCredentialType? =
        when (this) {
            None -> null
            Jwt -> AuthCredentialType.SessionJwt
            SessionToken -> AuthCredentialType.SessionToken
        }
}
